'use client';

import React from 'react';
import { Skull, AlertTriangle, TrendingDown, Activity, ShieldAlert, BarChart2 } from 'lucide-react';
import { StatCard } from '@/components/ui/Cards';


export default function MortalitySummaryCards() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mb-5">
      <StatCard label="Today's Deaths" value="29" sub="Across all flocks" icon={Skull} iconBg="#fef2f2" iconColor="#dc2626" alert alertVariant="danger" />
      <StatCard label="Today's Culled" value="5" sub="Removed from flocks" icon={TrendingDown} iconBg="#fffbeb" iconColor="#d97706" />
      <StatCard label="Threshold Alerts" value="1" sub="BR-2026-003 breached" icon={AlertTriangle} iconBg="#fff7ed" iconColor="#c2410c" alert alertVariant="warning" />
      <StatCard label="Under Investigation" value="3" sub="Records pending confirmation" icon={ShieldAlert} iconBg="#faf5ff" iconColor="#7c3aed" />
      <StatCard label="7-Day Total" value="91" sub="All causes combined" icon={Activity} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="Avg Daily Mortality %" value="0.14%" sub="Farm-wide this week" icon={BarChart2} iconBg="#f0fdf4" iconColor="#15803d" />
    </div>
  );
}
